import PermissionRepository from '@/shared/http/repositories/access/permission'
import { mutationTypes as mutation } from './mutations'
import { actionTypes as action } from './actionTypes'

export const actions = {

  async [action.GET_ALL_PERMISSIONS] ({ commit }, payload) {
    return PermissionRepository.GetAll(payload)
      .then((res) => {
        commit(mutation.SET_PERMISSIONS, res.data.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/permission/actions.js